$(document).ready(function() {
  let openBlock = $('#open-block-container'),
    closeBlock = $('#close-block-container'),
    saveBlock = $('#save-block-container'),
    readMore = $('.description .js-read-more'),
    descriptionContainer = $('#description-container');

  if (openBlock.length && closeBlock.length && saveBlock.length) {
    openBlock.on('click', function () {
      openBlock.addClass('is-hidden');
      readMore.addClass('is-hidden');
      descriptionContainer.removeClass('is-hidden');
      closeBlock.removeClass('is-hidden');
      saveBlock.removeClass('is-hidden');
    });

    closeBlock.on('click', function () {
      closeBlock.addClass('is-hidden');
      readMore.removeClass('is-hidden');
      descriptionContainer.addClass('is-hidden');
      openBlock.removeClass('is-hidden');
      saveBlock.addClass('is-hidden');
    });
  }

  const $emailInput = $(".newsletter-wrapper #footer-email");
  const $checkbox = $(".newsletter-wrapper #email-age");
  const $submitButton = $(".newsletter-wrapper button[type='submit']");

  // Fonction pour valider l'adresse e-mail
  const isValidEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  // Fonction pour activer ou désactiver le bouton
  const toggleSubmitButton = () => {
    if (isValidEmail($emailInput.val()) && $checkbox.is(":checked")) {
      $submitButton.prop("disabled", false);
    } else {
      $submitButton.prop("disabled", true);
    }
  };

  // Désactiver le bouton au chargement de la page
  $submitButton.prop("disabled", true);

  // Ajouter des écouteurs d'événements
  $emailInput.on("input", toggleSubmitButton);
  $checkbox.on("change", toggleSubmitButton);
});
